/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Comment_Field_EmergencyInputs */

const en_comment_field_emergency = /** @type {(inputs: Comment_Field_EmergencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emergency`)
};

const ja_comment_field_emergency = /** @type {(inputs: Comment_Field_EmergencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`緊急`)
};

const fr_comment_field_emergency = /** @type {(inputs: Comment_Field_EmergencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urgence`)
};

const de_comment_field_emergency = /** @type {(inputs: Comment_Field_EmergencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notfall`)
};

/**
* | output |
* | --- |
* | "Emergency" |
*
* @param {Comment_Field_EmergencyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const comment_field_emergency = /** @type {((inputs?: Comment_Field_EmergencyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Comment_Field_EmergencyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_comment_field_emergency(inputs)
	if (locale === "ja") return ja_comment_field_emergency(inputs)
	if (locale === "fr") return fr_comment_field_emergency(inputs)
	return de_comment_field_emergency(inputs)
});